<template>
    <div>
        <tab name="7">{{userName}}(ID:{{id}})</tab>
        <user-finance :userId="id" :userType="5" :userName.sync="userName"></user-finance>
    </div>
</template>

<script>
import Tab from './components/tab';
import UserFinance from '@/views/user/components/user-finance';
export default {
    props:{
        id:{
            type:[Number,String],
            default: ''
        }
    },
    components:{
        Tab,UserFinance
    },
    data() {
        return {
            userName:''
        };
    }
}
</script>